export interface TrafficData {
  time: string;
  eastus2: number;
  euwest1: number;
  northeurope: number;
  useast1: number;
}

// Convert TiB values to GB for easier processing
const convertTiBToGB = (tibValue: string): number => {
  const numValue = parseFloat(tibValue.replace(' TiB', ''));
  return Math.round(numValue * 1024); // 1 TiB = 1024 GB
};

export const trafficData: TrafficData[] = [
  {
    time: "2025-08-26",
    eastus2: convertTiBToGB("1.42 TiB"), // 1454 GB
    euwest1: convertTiBToGB("1.39 TiB"), // 1423 GB  
    northeurope: convertTiBToGB("1.35 TiB"), // 1382 GB
    useast1: convertTiBToGB("1.48 TiB") // 1515 GB
  },
  {
    time: "2025-08-27",
    eastus2: convertTiBToGB("1.46 TiB"), // 1495 GB
    euwest1: convertTiBToGB("1.41 TiB"), // 1444 GB
    northeurope: convertTiBToGB("1.38 TiB"), // 1413 GB
    useast1: convertTiBToGB("1.52 TiB") // 1556 GB
  },
  {
    time: "2025-08-28",
    eastus2: convertTiBToGB("1.57 TiB"), // 1607 GB
    euwest1: convertTiBToGB("1.54 TiB"), // 1577 GB
    northeurope: convertTiBToGB("1.49 TiB"), // 1526 GB
    useast1: convertTiBToGB("1.61 TiB") // 1649 GB
  },
  {
    time: "2025-08-29",
    eastus2: convertTiBToGB("1.57 TiB"), // 1607 GB
    euwest1: convertTiBToGB("1.55 TiB"), // 1587 GB
    northeurope: convertTiBToGB("1.51 TiB"), // 1548 GB
    useast1: convertTiBToGB("1.62 TiB") // 1659 GB
  },
  {
    time: "2025-08-30",
    eastus2: convertTiBToGB("1.64 TiB"), // 1679 GB
    euwest1: convertTiBToGB("1.61 TiB"), // 1649 GB
    northeurope: convertTiBToGB("1.57 TiB"), // 1607 GB
    useast1: convertTiBToGB("1.68 TiB") // 1720 GB
  },
  {
    time: "2025-08-31",
    eastus2: convertTiBToGB("1.86 TiB"), // 1904 GB
    euwest1: convertTiBToGB("1.82 TiB"), // 1863 GB
    northeurope: convertTiBToGB("1.78 TiB"), // 1823 GB
    useast1: convertTiBToGB("1.89 TiB") // 1936 GB
  },
  {
    time: "2025-09-01",
    eastus2: convertTiBToGB("1.40 TiB"), // 1434 GB
    euwest1: convertTiBToGB("1.37 TiB"), // 1402 GB
    northeurope: convertTiBToGB("1.33 TiB"), // 1362 GB
    useast1: convertTiBToGB("1.44 TiB") // 1474 GB
  },
  {
    time: "2025-09-02",
    eastus2: convertTiBToGB("1.42 TiB"), // 1454 GB
    euwest1: convertTiBToGB("1.39 TiB"), // 1423 GB
    northeurope: convertTiBToGB("1.35 TiB"), // 1382 GB
    useast1: convertTiBToGB("1.46 TiB") // 1495 GB
  }
];

export const regionColors = {
  eastus2: "#22c55e", // Green
  euwest1: "#fbbf24", // Yellow  
  northeurope: "#3b82f6", // Blue
  useast1: "#f97316" // Orange
};

export const formatTrafficValue = (value: number): string => {
  if (value >= 1000) {
    return `${(value / 1024).toFixed(2)} TiB`;
  }
  return `${value} GB`;
};
